/**
 * 学校/教师端项目壳配置（工作室 / 品牌 / 微课）
 * 第 1 步：仅配置，业务页暂未接入
 */
import { AUDIT_TYPE_MAP } from "@/components/auditPage/data.js";

/** 主单审核状态 */
export const AUDIT_STATE = {
  DRAFT: "0", // 已保存
  PENDING: "1", // 待审核
  APPROVED: "2", // 审核通过
  REJECTED: "3", // 审核驳回
};

/** 变更明细状态（更新详情内） */
export const DETAIL_AUDIT_STATE = {
  PENDING: "1", // 待审核 → 对应详情 Tab「变更请求」
  APPROVED: "2", // 已通过 → 对应详情 Tab「变更历史」
  REJECTED: "3", // 已驳回 → 对应详情 Tab「变更历史」
};

/** 详情 Tab */
export const DETAIL_TABS = [
  { key: "current", label: "现状", tip: "相当于原预览（只读）" },
  { key: "history", label: "变更历史", tip: "更新明细中已通过 + 已驳回" },
  { key: "requests", label: "变更请求", tip: "待提交草稿 + 待审核变更" },
];

/**
 * 三模块配置
 * moduleType: studio | brand | course
 */
export const MODULE_CONFIG = {
  studio: {
    moduleType: "studio",
    applyType: "1",
    title: "思政教育工作室",
    nameLabel: "工作室名称",
    searchPlaceholder: "搜索名称/负责人",
    routeList: "szStudio",
    routeUpload: "szStudioDataUpload",
    routeAudit: "szStudioAuditPage",
    auditPath: "/personalCenter/szStudio/auditPage",
    routeDetail: "szStudioProjectDetail",
    routeUpdate: "szStudioProjectUpdate",
    sideModules: AUDIT_TYPE_MAP[1],
    cardFields: [
      { key: "leader", label: "负责人", from: "principals", icon: "leader" },
      { key: "year", label: "申报年份", from: "applyYear", icon: "year" },
      { key: "version", label: "当前版本", from: "version|applyVersion|currentVersion", icon: "version" },
      { key: "updated", label: "最近更新", from: "updateTime|createTime|foundTime", icon: "update" },
      { key: "org", label: "所属单位", from: "belongDepartment", icon: "org", full: true },
    ],
    statLabels: {
      total: "思政教育工作室总数",
      approved: "已通过（现行有效）",
      pending: "待审核（含首次申报）",
      requests: "变更请求",
    },
  },
  brand: {
    moduleType: "brand",
    applyType: "2",
    title: "特色文化育人品牌",
    nameLabel: "品牌名称",
    searchPlaceholder: "搜索名称/负责人",
    routeList: "educationalBrand",
    routeUpload: "educationalBrandDataUpload",
    routeAudit: "educationalBrandAuditPage",
    auditPath: "/personalCenter/educationalBrand/auditPage",
    routeDetail: "educationalBrandProjectDetail",
    routeUpdate: "educationalBrandProjectUpdate",
    sideModules: AUDIT_TYPE_MAP[2],
    cardFields: [
      { key: "leader", label: "负责人", from: "principals", icon: "leader" },
      { key: "year", label: "申报年份", from: "applyYear", icon: "year" },
      { key: "version", label: "当前版本", from: "version|applyVersion|currentVersion", icon: "version" },
      { key: "updated", label: "最近更新", from: "updateTime|createTime|foundTime", icon: "update" },
      { key: "org", label: "所属单位", from: "belongDepartment", icon: "org", full: true },
    ],
    statLabels: {
      total: "特色文化育人品牌总数",
      approved: "已通过（现行有效）",
      pending: "待审核（含首次申报）",
      requests: "变更请求",
    },
  },
  course: {
    moduleType: "course",
    applyType: "3",
    title: "思政微课",
    nameLabel: "思政微课名称",
    searchPlaceholder: "搜索名称/负责人",
    routeList: "szMicroClass",
    routeUpload: "szMicroClassDataUpload",
    routeAudit: "szMicroClassAuditPage",
    auditPath: "/personalCenter/szMicroClass/auditPage",
    routeDetail: "szMicroClassProjectDetail",
    routeUpdate: "szMicroClassProjectUpdate",
    sideModules: AUDIT_TYPE_MAP[3],
    cardFields: [
      { key: "leader", label: "负责人", from: "principals", icon: "leader" },
      { key: "year", label: "申报年份", from: "applyYear", icon: "year" },
      { key: "version", label: "当前版本", from: "version|applyVersion|currentVersion", icon: "version" },
      { key: "updated", label: "最近更新", from: "updateTime|createTime|foundTime", icon: "update" },
      { key: "org", label: "所属单位", from: "belongDepartment", icon: "org", full: true },
    ],
    statLabels: {
      total: "思政微课总数",
      approved: "已通过（现行有效）",
      pending: "待审核（含首次申报）",
      requests: "变更请求",
    },
  },
};

export function getModuleConfig(moduleType) {
  return MODULE_CONFIG[moduleType] || MODULE_CONFIG.studio;
}

export function getModuleConfigByApplyType(applyType) {
  const type = String(applyType);
  return (
    Object.values(MODULE_CONFIG).find((m) => m.applyType === type) ||
    MODULE_CONFIG.studio
  );
}

/** 思政工作室、特色文化育人品牌、思政微课：学校→教育局两级审核（仅学校/教师端） */
export function isTwoLevelAuditModule(moduleType) {
  return (
    moduleType === "studio" ||
    moduleType === "brand" ||
    moduleType === "course"
  );
}

export function isTwoLevelApplyType(applyType) {
  const t = String(applyType);
  return t === "1" || t === "2" || t === "3";
}

/** 主单状态 → 展示文案 / 徽标类型 */
export const AUDIT_STATE_META = {
  "0": { text: "已保存", badge: "gray", proto: "draft", cardText: "已保存" },
  "1": { text: "待审核", badge: "orange", proto: "pending", cardText: "待审核" },
  "2": { text: "审核通过", badge: "green", proto: "approved", cardText: "已通过" },
  "3": { text: "审核驳回", badge: "red", proto: "rejected", cardText: "已驳回" },
};

function normalizeAuditVal(v) {
  if (v == null || v === "" || v === "null" || v === "NULL" || v === "undefined") {
    return null;
  }
  return String(v);
}

/**
 * 两级审核状态中文（学校/教师端按 auditState + auditLevel 对照，工作室/品牌/微课共用）：
 * 0/空 → 未提交；1+level1/空 → 待学校审核；1+level2 → 待教育局审核；
 * 2 → 审核通过；3+level1/空 → 学校驳回；3+level2 → 教育局驳回
 */
export function getCourseAuditStateText(record) {
  if (!record) return "未提交";
  const s = normalizeAuditVal(record.auditState);
  const lv = normalizeAuditVal(record.auditLevel);
  if (s == null || s === "0") return "未提交";
  if (s === "1") return lv === "2" ? "待教育局/厅审核" : "待学校审核";
  if (s === "2") return "审核通过";
  if (s === "3") return lv === "2" ? "教育局/厅驳回" : "学校驳回";
  return "未提交";
}

/** 思政微课卡片徽标：文案 + 颜色 */
export function getCourseAuditStateMeta(record) {
  const text = getCourseAuditStateText(record);
  const s = normalizeAuditVal(record && record.auditState);
  let badge = "gray";
  if (s === "1") badge = "orange";
  else if (s === "2") badge = "green";
  else if (s === "3") badge = "red";
  return { text, cardText: text, badge };
}

/** 思政微课状态文字颜色（表格用） */
export function getCourseAuditStateColor(record) {
  const s = normalizeAuditVal(record && record.auditState);
  if (s === "1") return "#1890ff";
  if (s === "2") return "rgb(46, 190, 73)";
  if (s === "3") return "#e1301e";
  return "#4b5563";
}

/**
 * 思政微课筛选值 → 接口参数
 * 0 | 1-1 | 1-2 | 2 | 3 | 3-1 | 3-2
 */
export function parseCourseAuditFilter(value) {
  if (value == null || value === "") return {};
  const v = String(value);
  if (v === "1-1") return { auditState: "1", auditLevel: 1 };
  if (v === "1-2") return { auditState: "1", auditLevel: 2 };
  if (v === "3-1") return { auditState: "3", auditLevel: 1 };
  if (v === "3-2") return { auditState: "3", auditLevel: 2 };
  return { auditState: v };
}

/** 从申报单上取出版本号，展示为 v1 / v2 */
export function formatApplyVersion(p) {
  if (!p) return "";
  const raw =
    p.currentVersion != null && p.currentVersion !== ""
      ? p.currentVersion
      : p.version != null && p.version !== ""
      ? p.version
      : p.versionNo != null && p.versionNo !== ""
      ? p.versionNo
      : p.versionNum;
  if (raw === null || raw === undefined || raw === "") return "";
  const s = String(raw).trim();
  if (!s || s === "null" || s === "undefined") return "";
  if (/^v/i.test(s)) return s;
  return "v" + s;
}

export default MODULE_CONFIG;
